/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createVendorFromDiscriminatorValue, serializeReactivateVendorRequest, serializeVendor, type ErrorResponse, type InternalErrorResponse, type ReactivateVendorRequest, type Vendor } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/vendors/{vendorCode}/reactivate
 */
export interface ReactivateRequestBuilder extends BaseRequestBuilder<ReactivateRequestBuilder> {
    /**
     * Brings a deactivated vendor back, with everything it had. Reactivating a vendor that is already active succeeds and returns it unchanged. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Vendor>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ReactivateVendorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Vendor | undefined>;
    /**
     * Brings a deactivated vendor back, with everything it had. Reactivating a vendor that is already active succeeds and returns it unchanged. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ReactivateVendorRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ReactivateRequestBuilderUriTemplate = "{+baseurl}/api/vendors/{vendorCode}/reactivate";
/**
 * Metadata for all the requests in the request builder.
 */
export const ReactivateRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ReactivateRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createVendorFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReactivateVendorRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
